<template>
  <div class="no-trip-container p-12 pb-10 rounded border border-black-30 sm:border-0 sm:p-0 sm:mt-8">
    <div class="text-center">
      There are no trips running for this month, please select another month or search for other
      <a class="text-secondary font-medium mdsm:block" :href="searchLink">
        liveaboards available in {{ selectedMonthName }}
      </a>
    </div>

    <hr class="border border-black-30 my-12 sm:mt-8 sm:mb-6">

    <div class="calendar-section flex justify-between pt-1 mdsm:flex-wrap mdsm:justify-between">
      <div class="flex-none sm:w-full mdsm:mb-10 calendar-month" v-for="year in years" :key="year">
        <p class="text-center font-medium mb-6">{{ year }}</p>
        <div class="year-grid">
          <div v-for="month in 12" :key="month"
            @click="handleMonthClick(month, year)"
            class="month-item cursor-pointer rounded p-4 text-black-30 text-center"
            :class="{ 'is-selected': isTripAvailable(month, year) }">
            {{ monthLabels[month - 1] }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['resortId', 'countrySlug', 'selectedTime', 'guest'],
  data () {
    return {
      availableMonths: []
    }
  },
  computed: {
    years () {
      const today = moment().startOf('year')

      return [today.year(), today.year() + 1, today.year() + 2]
    },
    monthLabels () {
      return [
        'Jan', 'Feb', 'Mar', 'Apr',
        'May', 'Jun', 'Jul', 'Aug',
        'Sep', 'Oct', 'Nov', 'Dec'
      ]
    },
    selectedMonthName () {
      return moment(this.selectedTime).format('MMMM')
    },
    searchLink () {
      const from = moment(this.selectedTime).format('YYYY-MM-DD')

      if (this.guest) {
        return `/s/liveaboards/${this.countrySlug}?from=${from}&guests=${this.guest}`
      }

      return `/s/liveaboards/${this.countrySlug}?from=${from}`
    }
  },
  mounted () {
    const startYear = moment().year()
    const endYear = startYear + 2
    const api = `api/v1/liveaboard/get_trip/yearly/${startYear}/${endYear}/${this.resortId}`

    $.get(`${window.ZUBLU_VARIABLES.ODYSSEY_API}/${api}`)
      .done(response => {
        this.availableMonths = response.data
      })
      .fail()
    
  },
  methods: {
    isTripAvailable (month, year) {
      return this.availableMonths.some(item => item.year === year && item.month === month)
    },
    handleMonthClick (month, year) {
      const ele = document.querySelector('.itinerary-list-header')
      window.scrollTo({ top: ele.offsetTop, behavior: 'smooth' })

      window.requestAnimationFrame(() => {
        const monthPadded = String(month).padStart(2, '0')
        const newSelectedTime = `${year}-${monthPadded}-01`

        this.$emit('change', newSelectedTime)
      })
    }
  }
}
</script>

<style scoped>
.year-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  column-gap: 16px;
  row-gap: 16px;
}

.month-item.is-selected {
  color: var(--black);
  background-color: var(--cyan-light-1);
}

@media (min-width: 600px) and (max-width: 800px) { /* Special breakpoints */
  .calendar-section > div {
    margin-left: 100px;
    margin-right: 100px;
  }

  .calendar-section {
    justify-content: center;
  }
}

@media (max-width: 600px) {
  .no-trip-container {
    border: none;
  }

  .calendar-month {
    max-width: 320px;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
